import { Injectable } from '@angular/core';
import { HttpResponse, HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable()
export class ContactoService {
  urlSendEmail:string = 'http://industrialrobotics.com.mx/api/EnviarEmail.php';
  constructor(public http: HttpClient) { 
    console.log('Servicio de Mail Listo'); 
    
  }
  sendEmail(Contacto:string) {
    let params = "data="+Contacto;
 
    //Establecemos cabeceras
    let headers = new HttpHeaders().set('Content-Type','application/x-www-form-urlencoded');
         
    return this.http.post(this.urlSendEmail, params, {headers: headers});
  }

}
